// extracted by mini-css-extract-plugin
module.exports = {"uk-pc-delivery":"style_uk-pc-delivery__oH20N"};